module.exports = __webpack_public_path__ + "static/media/SE_reading.9b8beb06.mp4";